import React, { useEffect } from "react";
import { FormattedMessage } from "react-intl";
import { useFormContext } from "react-hook-form";

import useSortedPaymentLocations from "hooks/useSortedPaymentLocations";
import DownloadTemplateFilter from "./DownloadTemplateFilter";

function DownloadTemplateLocationFilter() {
  const paymentLocations = useSortedPaymentLocations();
  const { setValue } = useFormContext();

  useEffect(() => {
    if (paymentLocations?.length) {
      setValue(
        "selected_payment_locations",
        paymentLocations.map((item) => item.value),
      );
    }
  }, [paymentLocations]);

  return (
    <div className="d-flex flex-wrap">
      <div className="mb-xs-3 mb-sm-3 download-filter-title">
        <div className="mb-1">
          <h6>
            <FormattedMessage id="report.paymentLocation" defaultMessage="Payment Location" />
          </h6>
        </div>
        <div className="font-b3 text-secondary">
          <FormattedMessage id="settings.fileImportTools.chooseTeamName" defaultMessage="Choose team names" />
        </div>
      </div>

      {!!paymentLocations.length && <DownloadTemplateFilter name="selected_payment_locations" options={paymentLocations} />}
    </div>
  );
}

export default DownloadTemplateLocationFilter;
